import { render, staticRenderFns } from "./NewServices.vue?vue&type=template&id=bc9d0256&scoped=true&"
import script from "./NewServices.vue?vue&type=script&lang=js&"
export * from "./NewServices.vue?vue&type=script&lang=js&"
import style0 from "./NewServices.vue?vue&type=style&index=0&id=bc9d0256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d0256",
  null
  
)

export default component.exports